// src/App.tsx
import React, { useState } from "react";
import HomePage from "./components/HomePage";
import GameSelector from "./components/GameSelector";
import PhoneNumberGame from "./components/PhoneNumberGame";
import NumberRangeGame from "./components/NumberRangeGame";
import MathProblemGame from "./components/MathProblemGame";
import './App.css';
import TimeOfDayGame from "./components/TimeOfDayGame";

const App: React.FC = () => {
  const [selectedCountry, setSelectedCountry] = useState<string | null>(null);
  const [selectedGame, setSelectedGame] = useState<string | null>(null);
  const [currentScreen, setCurrentScreen] = useState<'home' | 'gameSelector' | 'phoneNumbers'>('home');

  const handleBack = () => {
    if (currentScreen === 'phoneNumbers') {
      setCurrentScreen('gameSelector');
      setSelectedGame(null);
    } else if (currentScreen === 'gameSelector') {
      setCurrentScreen('home');
      setSelectedCountry(null);
    }
  };

  const handleCountrySelect = (abbr: string) => {
    setSelectedCountry(abbr);
    setCurrentScreen('gameSelector');
  };

  const handleGameSelect = (game: string) => {
    setSelectedGame(game);
    setCurrentScreen('phoneNumbers');
  };

  return (
    <div className="App">
      {/* Show back button if not on the homepage*/}
      {currentScreen !== 'home' && (
      <button className="back-button" onClick={handleBack}>
      ⬅️ Back
      </button>
      )}
      {!selectedCountry && <HomePage onCountrySelect={handleCountrySelect} />}
      {selectedCountry && !selectedGame && <GameSelector selectedCountry={selectedCountry} onGameSelect={handleGameSelect} />}
      {selectedGame === "phone_numbers" && selectedCountry && <PhoneNumberGame selectedCountry={selectedCountry} />}
      {selectedGame === "num_range_0_10" && selectedCountry && <NumberRangeGame selectedCountry={selectedCountry} minNum={0} maxNum={10} />}
      {selectedGame === "num_range_0_100" && selectedCountry && <NumberRangeGame selectedCountry={selectedCountry} minNum={0} maxNum={100} />}
      {selectedGame === "math_easy" && selectedCountry && <MathProblemGame selectedCountry={selectedCountry} difficulty="easy" />}
      {selectedGame === "math_normal" && selectedCountry && <MathProblemGame selectedCountry={selectedCountry} difficulty="normal" />}
      {selectedGame === "time_of_day" && selectedCountry && <TimeOfDayGame selectedCountry={selectedCountry} />}
    </div>
  );
};

export default App;
